"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameMode = void 0;
var GameMode;
(function (GameMode) {
    GameMode[GameMode["Unknown"] = 0] = "Unknown";
    GameMode[GameMode["Live"] = 1] = "Live";
    GameMode[GameMode["Managed"] = 2] = "Managed";
    GameMode[GameMode["PreMatch"] = 3] = "PreMatch";
    GameMode[GameMode["Manual"] = 4] = "Manual";
    GameMode[GameMode["Premium"] = 5] = "Premium";
    GameMode[GameMode["VirtualFootball"] = 6] = "VirtualFootball";
    GameMode[GameMode["NumbersBetting"] = 7] = "NumbersBetting";
    GameMode[GameMode["VirtualBasketball"] = 8] = "VirtualBasketball";
    GameMode[GameMode["VirtualTennis"] = 9] = "VirtualTennis";
    GameMode[GameMode["VirtualDogRacing"] = 10] = "VirtualDogRacing";
    GameMode[GameMode["VirtualHorseRacing"] = 11] = "VirtualHorseRacing";
    GameMode[GameMode["VirtualTennisLive"] = 12] = "VirtualTennisLive";
    GameMode[GameMode["VirtualBaseballLive"] = 15] = "VirtualBaseballLive";
    GameMode[GameMode["VirtualHockey"] = 16] = "VirtualHockey";
})(GameMode = exports.GameMode || (exports.GameMode = {}));
